import axios from 'axios';
import Server from 'common/conf/Server';
import ServerTwo from 'common/conf/ServerTwo';
import store from 'store';
import router from '../../router'
import StorageService from "../../store/interfaces";
import ElementUI from 'element-ui';
import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
import privateKey from 'service/constant/privateKey';
import { Loading } from 'element-ui';
import {loadMixin, dialogMixin, validatorsMixin} from "mixin";


export const getToken = () => {
    return store.getters.userToken
};

export const getUserId = () => {
    
    return store.getters.userId
};

export const getTatSimpleId = () => {
    console.log(store.getters.tatSimpleId,'store.getters.tatSimpleId')
    return store.getters.userInfo.tatSimpleId
    // return true
};

const CommonParams = {
    tatId: getTatSimpleId(),
    modifierId:getUserId() ? getUserId() : '',
    modifier:getUserId() ? getUserId() : '',
    serverType: '1',
    
};

export const fillData = (data, FileType) => {
    const result = Object.assign({}, CommonParams, {
        reqTime: new Date().format('yyyy-MM-dd HH:mm:ss'),
    }, data);
    if (getUserId()) {
        result.modifierId = getUserId();
        result.modifier = getUserId();
        result.tatId = getTatSimpleId();
        if(getTatSimpleId() != '144a3ff3da0fbc619cc305a32d4e857c') {
            result.tatSimpleId = getTatSimpleId()
        }
     
    }
    for (let key in result) {
        if ((null == result[key] || undefined == result[key]) && key != 'remark') {
            delete result[key];
        }
        if (typeof (result[key]) == 'String'){
            result[key] = result[key].trim();
        }
    }

    // console.log(urlEncode(objKeySort(result)) + '&priKey=' + privateKey.priKey)
    result.sign = encrypt(urlEncode(objKeySort(result)) + '&priKey=' + privateKey.priKey);
    if (FileType) { 
        for (let key in result) {
            data.append(key, result[key])
        }
        return data;
    }

    return result;
};


const RespStatus = {
    Success: 200
};

const RespCodes = {
    Success: '0000'
};

export const Host = Server[process.env.NODE_ENV];

export const newHostServer = ServerTwo[process.env.NODE_ENV];

export function get(url, data, host, needToken) {
    let loadingInstanceget = Loading.service({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
    });
    // return axios.get((host || Host) + url, {
    return axios.get(Host + host + url, {
        // headers: header || {Authorization: getToken()},
        headers: Object.assign({
            "Content-Type":"application/x-www-form-urlencoded;multipart/form-data"
        }, needToken ? {token: getToken()} : {}),
        params: Object.assign({}, CommonParams, fillData(data)),
    }).then((resp) => {
        loadingInstanceget.close();
        if (RespStatus.Success != resp.status || resp.data == undefined || resp.data == null || (resp.data.respCode && (resp.data.respCode != 'A001' && resp.data.respCode != '0000')) || (!resp.data.respCode && !resp.data.success && !resp.data.rows)) {
            return Promise.reject({resp: resp, message: shelling(resp)});
        }
        return Promise.resolve(resp.data.data == undefined ? resp.data: resp.data.data);
    }, (error) => {
        loadingInstanceget.close();
        console.log('[Get请求-请求失败]', error);
        return Promise.reject({resp: error, message: shelling(error)});
    }).catch((e) => {
        loadingInstanceget.close();
        console.log('[Get请求-发生异常]', e);
        return Promise.reject(e);
    });
}

export function outter_get(url, data, host) {
    return get(url, data, host, false, true);
}

export function post(url, data, host, needToken,FileType, needTest, newHostServer) {

    return axios.post( (needTest ? 'https://test.xinchuangquan.cn' : (newHostServer ? newHostServer : Host)) + host + url, FileType ? fillData(data, FileType) : Object.assign({}, CommonParams, fillData(data, FileType)), {
        headers: Object.assign({
            "Content-Type": FileType ? "multipart/form-data" : 'application/x-www-form-urlencoded'
        }, needToken ? {token: getToken()} : {}),
        transformRequest: [function (data) {
            if (FileType) {
         
                return data
            } else {
                console.log(data,'传值')
                let ret = '';
                for (let it in data) {
                    ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
                }
                return ret
            }
        }]
    }).then((resp) => {
        if (RespStatus.Success != resp.status || (!resp.data && "" != resp.data)
            || RespCodes.Success != resp.data.respCode || (resp.data.contents && resp.data.contents.optStatus && RespCodes.Success != resp.data.contents.optStatus)) {
            console.log('[Post请求-服务端返回错误响应]', resp);
            return Promise.reject({resp: resp, message: shelling(resp)});
        }

        if (resp.data.respCode == '0003') {
            router.replace({
                name:'Login'
            });

            ElementUI.Message.closeAll();
            ElementUI.Message({
                message: '登录超时，请重新登录',
                type: 'error',
            });
        }

        return Promise.resolve(resp.data);
    }, (error) => {
        console.log('[Post请求-请求失败]', error, shelling(error));
        return Promise.reject({resp: error, message: shelling(error)});
    });
}

export function outter_post(url, data, host) {
    return post(url, data, host, false, false, false);
}
export function outter_post_newUrl(url, data, host) {
    return post(url, data, host, false, false, false, newHostServer);
}
export function outter_post_test(url, data, host) {
    return post(url, data, host, false, false, true);
}

export function file_post(url, data, host) {
    return post(url, data, host, false, true, false);
}

export const shelling = (resp) => {
    const defaultMsg = '未知错误';
    if (resp.message && resp.message.indexOf('timeout') > -1) {
        wx.hideLoading();
        return '请求超时，请稍后重试';
    }

    if (!resp) {
        return defaultMsg;
    }
    if (!resp.data) {
        return resp.statusText || resp.status + ':' + defaultMsg;
    }
    if (!resp.data.contents || !resp.data.contents.optStatus) {
        return resp.data.respCode + ':' + (resp.data.respMsg || defaultMsg);
    }
    return resp.data.contents.optMsg || resp.data.contents.optStatus + ':' + defaultMsg;
};



// WEBPACK FOOTER //
// ./src/common/js/axios-helper.js